import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { ConvertPriceToString } from '../../../Helpers/CustomConverter';
import LoadingSpinner from '../../Components/LoadingSpinner';

const CreditLimitCard = ({ isLoading, creditLimit }) => {
    const [limit, setLimit] = useState(0.0)
    const [isChangeLimitVisible, setIsChangeLimitVisible] = useState(false);

    const handleEditLimit = (e) => {
        const { value } = e.target.value;
        setLimit(value)
    }
    const handleCancelButtonClick = () => {
        setLimit(0.0)
        setIsChangeLimitVisible(false);
    }

    const handleChangeLimitButtonClick = () => {
        setIsChangeLimitVisible(true);
    }

    const handleChangeLimit = () => {
        setLimit(0.0)
        setIsChangeLimitVisible(false);
    }
    return (
        <div>
            <div className='row justify-content-center'>
                <div className='justify-content-center mt-2'>
                    <div>
                        <Modal size='md' show={isChangeLimitVisible} onHide={handleCancelButtonClick} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Zmień limit</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <ChangeCreditLimit handleEditLimit={handleEditLimit} handleChangeLimit={handleChangeLimit} />
                            </Modal.Body>
                        </Modal>
                        <div className='panel-header-title'>Limit kredytowy</div>
                        {isLoading && <LoadingSpinner />}
                        {!isLoading && <div className='row'>
                            <div className='col-auto ms-1'>Dostępny limit:<br />  <span style={{ fontWeight: 'bold', fontSize: '25px' }}>{ConvertPriceToString(creditLimit.remainCredit)}</span></div>
                            <div className='col-auto ms-1'>Całkowity limit:<br /> <span style={{ fontWeight: 'bold', fontSize: '25px' }}>{ConvertPriceToString(creditLimit.grantCredit)}</span></div>
                        </div>}
                        {/* <Button variant="outline-danger" size="md" style={{ marginBottom: 5, marginTop: 5, marginRight: 5 }}>
                            Spłać
                        </Button> */}
                        {/* <button className='btn-app-primary mt-3' onClick={handleChangeLimitButtonClick}>
                            Zwiększ limit
                        </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ChangeCreditLimit = ({ handleEditLimit, handleChangeLimit }) => {
    return <>
        <div className="cont profile-details-info">
            <div className="row data-container mt-2">
                <div className="col">
                    <Form.Control type='number' name='newLimit' placeholder='Podaj wnioskowaną kwotę' onChange={handleEditLimit} autoFocus required />
                </div>
            </div>
            <div className="row data-container mt-4">
                <div className="col d-grid">
                    <button className='btn-app-primary' onClick={handleChangeLimit}>
                        Wnioskuj o zmianę
                    </button>
                </div>
                <div className='col d-grid'></div>
            </div>
        </div>
    </>
}

export default CreditLimitCard;